import { render, staticRenderFns } from "./elevator-warning.vue?vue&type=template&id=52f1e9b9&scoped=true&"
import script from "./elevator-warning.vue?vue&type=script&lang=js&"
export * from "./elevator-warning.vue?vue&type=script&lang=js&"
import style0 from "./elevator-warning.vue?vue&type=style&index=0&id=52f1e9b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f1e9b9",
  null
  
)

export default component.exports